import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-lg p-8"
        >
          <div className="flex items-center gap-4 mb-8">
            <Shield className="w-8 h-8 text-purple-600" />
            <h1 className="text-3xl font-bold text-gray-900">
              Polityka Prywatności
            </h1>
          </div>

          <div className="prose prose-purple max-w-none">
            <p className="lead">
              Ochrona Twoich danych osobowych jest dla nas priorytetem. Poniżej znajdziesz szczegółowe
              informacje o tym, jak przetwarzamy Twoje dane.
            </p>

            <h2>1. Administrator danych</h2>
            <p>
              Administratorem Twoich danych osobowych jest Kariera z AI, kontakt:
              polokontaktowy@gmail.com
            </p>

            <h2>2. Jakie dane zbieramy?</h2>
            <ul>
              <li>Dane podane podczas rejestracji (email)</li>
              <li>Odpowiedzi z wypełnionego quizu predyspozycji</li>
              <li>Dane o podstawowych interakcjach z platformą</li>
              <li>Informacje o zakupionych usługach</li>
            </ul>

            <h2>3. Cel przetwarzania danych</h2>
            <ul>
              <li>Świadczenie usług doradztwa zawodowego</li>
              <li>Personalizacja ścieżki rozwoju</li>
              <li>Analiza predyspozycji zawodowych</li>
              <li>Rekomendacje zawodowe</li>
            </ul>

            <h2>4. Podstawa prawna</h2>
            <p>
              Przetwarzamy Twoje dane na podstawie:
            </p>
            <ul>
              <li>Zgody wyrażonej podczas rejestracji</li>
              <li>Konieczności wykonania umowy</li>
              <li>Realizacji usługi doradztwa zawodowego</li>
            </ul>

            <h2>5. Okres przechowywania</h2>
            <p>
              Twoje dane przechowujemy przez okres korzystania z platformy. Po usunięciu konta
              wszystkie dane są trwale usuwane z naszych systemów.
            </p>

            <h2>6. Twoje prawa</h2>
            <p>
              Masz prawo do:
            </p>
            <ul>
              <li>Dostępu do swoich danych</li>
              <li>Sprostowania danych</li>
              <li>Usunięcia danych ("prawo do zapomnienia")</li>
              <li>Ograniczenia przetwarzania</li>
              <li>Przenoszenia danych</li>
              <li>Wniesienia sprzeciwu</li>
            </ul>

            <h2>7. Pliki cookies</h2>
            <p>
              Używamy plików cookies do:
            </p>
            <ul>
              <li>Zapewnienia podstawowej funkcjonalności strony</li>
              <li>Analizy ruchu na stronie (Google Analytics)</li>
              <li>Zapamiętywania preferencji użytkownika</li>
            </ul>
            <p>
              Szczegółowe informacje o plikach cookies znajdziesz w naszej
              <a href="/cookies" className="text-purple-600 hover:text-purple-700"> Polityce Cookies</a>.
            </p>
            <h2>8. Kontakt</h2>
            <p>
              W sprawach związanych z ochroną danych osobowych możesz kontaktować się z nami pod adresem: polokontaktowy@gmail.com
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
